"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[965],{

/***/ 30006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ActionType; }
/* harmony export */ });
var ActionType;
(function(ActionType) {
    ActionType[// Cache
    "CACHE__REGENERATE_ALL_STATIC_PAGES"] = "CACHE__REGENERATE_ALL_STATIC_PAGES";
    ActionType[// JobPost
    "JOB_POST__CREATE"] = "JOB_POST__CREATE";
    ActionType["JOB_POST__UPDATE"] = "JOB_POST__UPDATE";
    ActionType["JOB_POST__SET_META"] = "JOB_POST__SET_META";
    ActionType["JOB_POST__SET_HIRING_ORGANISATION"] = "JOB_POST__SET_HIRING_ORGANISATION";
    ActionType["JOB_POST__SET_SOURCING_ORGANISATION"] = "JOB_POST__SET_SOURCING_ORGANISATION";
    ActionType["JOB_POST__CHANGE_OWNER"] = "JOB_POST__CHANGE_OWNER";
    ActionType["JOB_POST__INDEX"] = "JOB_POST__INDEX";
    ActionType["JOB_POST__UNINDEX"] = "JOB_POST__UNINDEX";
    ActionType["JOB_POST__APPROVE"] = "JOB_POST__APPROVE";
    ActionType["JOB_POST__STOP"] = "JOB_POST__STOP";
    ActionType["JOB_POST__RESUME"] = "JOB_POST__RESUME";
    ActionType["JOB_POST__DELETE"] = "JOB_POST__DELETE";
    ActionType[// Organisation
    "ORGANISATION__UPSERT"] = "ORGANISATION__UPSERT";
    ActionType["ORGANISATION__DELETE"] = "ORGANISATION__DELETE";
    ActionType[// Order
    "ORDER__CAPTURE_PAYMENT"] = "ORDER__CAPTURE_PAYMENT";
    ActionType["ORDER__CANCEL_PAYMENT"] = "ORDER__CANCEL_PAYMENT";
    ActionType["ORDER__CREATE_INVOICE"] = "ORDER__CREATE_INVOICE";
    ActionType["ORDER__EMAIL_INVOICE"] = "ORDER__EMAIL_INVOICE";
    ActionType[// Twitter
    "TWITTER__TWEET_JOB_POST"] = "TWITTER__TWEET_JOB_POST";
})(ActionType || (ActionType = {}));


/***/ }),

/***/ 87881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ OptionalBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const OptionalBadge = (param)=>/*#__PURE__*/ {
    let {} = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "inline-flex items-center mx-0.5 px-1 py-0.5 rounded font-normal text-xs bg-gray-50 text-gray-400",
        children: "optional"
    });
};


/***/ }),

/***/ 32736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ RequiredBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const RequiredBadge = (param)=>/*#__PURE__*/ {
    let {} = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "inline-flex items-center mx-0.5 px-1 py-0.5 rounded font-normal text-xs bg-red-50 text-red-400",
        children: "required"
    });
};


/***/ }),

/***/ 27778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Badges_OptionalBadge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87881);
/* harmony import */ var _components_Badges_RequiredBadge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32736);
/* harmony import */ var _hookform_error_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32866);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43153);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60487);







const Input = (param)=>{
    let { label , hasOptionalBadge , hasRequiredBadge , path , placeholder , disabled =false , register , registerOptions ={} , type ="text" , errors ={} , labelCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultLabelCN */ .oi , inputCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultInputCN */ .Ln , inputErrorStateCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultInputErrorStateCN */ .pD , errorMessageCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultErrorMessageCN */ .yr , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: path,
                className: labelCN,
                children: [
                    label,
                    " ",
                    hasOptionalBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Badges_OptionalBadge__WEBPACK_IMPORTED_MODULE_1__/* .OptionalBadge */ .E, {}),
                    " ",
                    hasRequiredBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Badges_RequiredBadge__WEBPACK_IMPORTED_MODULE_2__/* .RequiredBadge */ .B, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: type,
                id: path,
                placeholder: placeholder,
                disabled: disabled,
                ...register(path, registerOptions),
                autoComplete: path,
                className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_5__/* .classNames */ .A)(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(errors, path) ? inputErrorStateCN : "", inputCN),
                ...rest
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hookform_error_message__WEBPACK_IMPORTED_MODULE_6__/* .ErrorMessage */ .B, {
                errors: errors,
                name: path,
                render: (param)=>/*#__PURE__*/ {
                    let { message  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: errorMessageCN,
                        children: message
                    });
                }
            })
        ]
    });
};


/***/ }),

/***/ 60487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ defaultSelectErrorStateCN; },
/* harmony export */   "Ln": function() { return /* binding */ defaultInputCN; },
/* harmony export */   "Uh": function() { return /* binding */ defaultDescriptionCN; },
/* harmony export */   "k3": function() { return /* binding */ defaultSelectCN; },
/* harmony export */   "oi": function() { return /* binding */ defaultLabelCN; },
/* harmony export */   "pD": function() { return /* binding */ defaultInputErrorStateCN; },
/* harmony export */   "yr": function() { return /* binding */ defaultErrorMessageCN; }
/* harmony export */ });
/* unused harmony exports defaultInputWithAddonCN, defaultAddonCN */
// Label
const defaultLabelCN = "block mb-1 text-sm font-medium text-gray-700";
// Input
const defaultInputCN = "block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-300 focus:ring-blue-500 focus:border-blue-500";
const defaultInputErrorStateCN = "border-red-500 bg-red-50";
// InputWithAddon
const defaultInputWithAddonCN = "flex-1 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300 placeholder-gray-300 focus:ring-blue-500 focus:border-blue-500";
const defaultAddonCN = "inline-flex px-3 items-center text-gray-500 sm:text-sm rounded-l-md border border-r-0 border-gray-300 bg-gray-50";
// Select
const defaultSelectCN = "block w-full pl-3 pr-10 py-2 text-base border-gray-300 sm:text-sm rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500";
const defaultSelectErrorStateCN = "border-red-500 bg-red-50";
// Description
const defaultDescriptionCN = "pt-1 px-2 text-xs text-gray-600";
// ErrorMessage
const defaultErrorMessageCN = "pt-1 px-2 text-xs text-red-600 rounded-b";


/***/ }),

/***/ 26353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ JobPostPurchaseHistory; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43153);
/* harmony import */ var _utils_formatters_moneyFormatter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59614);
/* harmony import */ var _components_Values_DateTimePreciseValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67389);





const JobPostPurchaseHistory = (param)=>{
    let { orderItems  } = param;
    // Sort by multiple fields (io.order.createdAt, io.sku.order) using chained sort.
    const sortedOrderItems = orderItems.sort((a, b)=>a.order.createdAt.getTime() - b.order.createdAt.getTime() || a.sku.sortOrder - b.sku.sortOrder);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "border rounded-md",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "p-4 pt-3 pb-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-xs uppercase leading-6 font-bold ",
                    children: "Purchase History"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "",
                children: orderItems.map((oi, idx)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_4__/* .classNames */ .A)("sm:flex sm:justify-between mx-4 pt-2 pb-3 text-xs border-green-900/10", idx > 0 ? "border-t" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-1 mb-1 font-bold",
                                            children: oi.sku.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: oi.sku.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-1 font-medium",
                                    children: _utils_formatters_moneyFormatter__WEBPACK_IMPORTED_MODULE_2__/* .moneyFormatter.format */ .e.format(oi.sku.priceAmount / 100)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-1 mb-1",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Values_DateTimePreciseValue__WEBPACK_IMPORTED_MODULE_3__/* .DateTimePreciseValue */ .V, {
                                        date: oi.createdAt
                                    })
                                })
                            ]
                        })
                    }, oi.id);
                })
            })
        ]
    });
};


/***/ }),

/***/ 97207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ JobPostSummary; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20518);
/* harmony import */ var _components_Values_JobPostCompositeStatusValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12670);
/* harmony import */ var _components_Values_DateTimeValue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29395);
/* harmony import */ var _utils_actions_executeAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65481);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var actions_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30006);








const JobPostSummary = (param)=>{
    let { jobPostId , compositeStatus , isSticky , createdAt , publishStartsAt , publishExpiresAt , stoppedAt , analytics  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border rounded-md",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pb-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mb-2 pt-4 px-4 border-b text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "uppercase text-xs font-bold",
                                    children: "Performance Analytics"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-xxs text-gray-400",
                                    children: "Updates hourly"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row justify-between mb-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-1/3 py-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-medium text-3xl",
                                            children: (analytics === null || analytics === void 0 ? void 0 : analytics.impressions) || 0
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-xxs",
                                            children: [
                                                "search",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                "impressions"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-1/3 py-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-medium text-3xl",
                                            children: (analytics === null || analytics === void 0 ? void 0 : analytics.detailViews) || 0
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-xxs",
                                            children: [
                                                "detail page",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                "views"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-1/3 py-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-medium text-3xl",
                                            children: (analytics === null || analytics === void 0 ? void 0 : analytics.applyClicks) || 0
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-xxs",
                                            children: [
                                                "apply button",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                "clicks"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 py-2 font-medium",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-1 uppercase font-normal text-xxs",
                            children: "Status"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-sm",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Values_JobPostCompositeStatusValue__WEBPACK_IMPORTED_MODULE_3__/* .JobPostCompositeStatusValue */ .d, {
                                        compositeStatus: compositeStatus
                                    })
                                }),
                                compositeStatus === _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.PUBLISHED */ .L.PUBLISHED && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "",
                                    title: "Unpublish job post",
                                    className: "ml-4 px-2 py-0.5 text-xxs hover:bg-gray-100 border border-black rounded-full",
                                    onClick: async (e)=>{
                                        e.preventDefault();
                                        await (0,_utils_actions_executeAction__WEBPACK_IMPORTED_MODULE_7__/* .executeAction */ .j)({
                                            actionType: actions_actions__WEBPACK_IMPORTED_MODULE_6__/* .ActionType.JOB_POST__STOP */ .U.JOB_POST__STOP,
                                            jobPostId
                                        });
                                        router.reload();
                                    },
                                    children: "unpublish"
                                }),
                                compositeStatus === _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.STOPPED */ .L.STOPPED && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "",
                                    title: "Re-publish job post",
                                    className: "ml-4 px-2 py-0.5 text-xxs hover:bg-gray-100 border rounded-full",
                                    onClick: async (e)=>{
                                        e.preventDefault();
                                        await (0,_utils_actions_executeAction__WEBPACK_IMPORTED_MODULE_7__/* .executeAction */ .j)({
                                            actionType: actions_actions__WEBPACK_IMPORTED_MODULE_6__/* .ActionType.JOB_POST__RESUME */ .U.JOB_POST__RESUME,
                                            jobPostId
                                        });
                                        router.reload();
                                    },
                                    children: "publish"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 py-2 font-medium",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-1 uppercase font-normal text-xxs",
                            children: "Sticky on homepage?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-row items-center text-xs",
                            children: isSticky ? "Yes" : "No"
                        })
                    ]
                }),
                createdAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 py-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-1 uppercase font-normal text-xxs",
                            children: "Created"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-medium text-xs",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Values_DateTimeValue__WEBPACK_IMPORTED_MODULE_4__/* .DateTimeValue */ .u, {
                                date: createdAt
                            })
                        })
                    ]
                }),
                (publishStartsAt || publishExpiresAt) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "px-4 py-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-1 uppercase font-normal text-xxs",
                                    children: "Published"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "font-medium text-xs",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Values_DateTimeValue__WEBPACK_IMPORTED_MODULE_4__/* .DateTimeValue */ .u, {
                                        date: publishStartsAt
                                    })
                                })
                            ]
                        }),
                        compositeStatus === _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.STOPPED */ .L.STOPPED && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "px-4 py-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-1 uppercase font-normal text-xxs",
                                    children: "Stopped"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "font-medium text-xs",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Values_DateTimeValue__WEBPACK_IMPORTED_MODULE_4__/* .DateTimeValue */ .u, {
                                        date: stoppedAt
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "px-4 py-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-1 uppercase font-normal text-xxs",
                                    children: "Expires"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "font-medium text-xs",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Values_DateTimeValue__WEBPACK_IMPORTED_MODULE_4__/* .DateTimeValue */ .u, {
                                        date: publishExpiresAt
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 67389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ DateTimePreciseValue; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34850);



const DateTimePreciseValue = (param)=>{
    let { date  } = param;
    return date ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(date), "dd MMM yy"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "p-0.5 text-gray-400",
                children: "-"
            }),
            (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(date), "HH:mm:ss")
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: "-"
    });
};


/***/ }),

/***/ 29395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ DateTimeValue; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34850);



const DateTimeValue = (param)=>{
    let { date  } = param;
    return date ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(date), "dd MMM yy"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "p-0.5 text-gray-400",
                children: "-"
            }),
            (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(date), "HH:mm")
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: "-"
    });
};


/***/ }),

/***/ 12670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ JobPostCompositeStatusValue; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20518);



const JobPostCompositeStatusValue = (param)=>{
    let { compositeStatus  } = param;
    switch(compositeStatus){
        case _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.DRAFT */ .L.DRAFT:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "inline-flex items-center px-2 py-0.5 rounded font-medium bg-orange-100 text-orange-600",
                children: "draft"
            });
        case _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.PENDING_APPROVAL */ .L.PENDING_APPROVAL:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "inline-flex items-center px-2 py-0.5 rounded font-medium bg-blue-100 text-blue-600",
                children: "pending review"
            });
        case _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.APPROVED */ .L.APPROVED:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "inline-flex items-center px-2 py-0.5 rounded font-medium bg-blue-100 text-blue-600",
                children: "approved"
            });
        case _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.PUBLISHED */ .L.PUBLISHED:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "inline-flex items-center px-2 py-0.5 rounded font-medium bg-green-100 text-green-600",
                children: "published"
            });
        case _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.STOPPED */ .L.STOPPED:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "inline-flex items-center px-2 py-0.5 rounded font-medium bg-red-100 text-red-600",
                children: "stopped"
            });
        case _utils_db_JobPost_getCompositeStatus__WEBPACK_IMPORTED_MODULE_2__/* .JobPostCompositeStatus.EXPIRED */ .L.EXPIRED:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "inline-flex items-center px-2 py-0.5 rounded font-medium bg-red-100 text-red-600",
                children: "expired"
            });
    }
};


/***/ }),

/***/ 65481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ executeAction; }
/* harmony export */ });
const executeAction = async (param)=>{
    let { actionType , ...rest } = param;
    return await fetch("/api/actions/execute-action", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            actionType,
            ...rest
        })
    }).then((res)=>res.json());
};


/***/ }),

/***/ 20518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ JobPostCompositeStatus; },
  "O": function() { return /* binding */ getCompositeStatus; }
});

;// CONCATENATED MODULE: ./utils/db/JobPost/getIsApproved.ts
const getIsApproved = (jobPost)=>{
    return !!jobPost.approvedAt && jobPost.approvedAt < new Date();
};

;// CONCATENATED MODULE: ./utils/db/JobPost/getIsExpired.ts
const getIsExpired = (jobPost)=>{
    return !!jobPost.publishExpiresAt && jobPost.publishExpiresAt < new Date();
};

;// CONCATENATED MODULE: ./utils/db/JobPost/getIsPaid.ts
const getIsPaid = (jobPost)=>{
    return !!jobPost.paymentCreatedAt;
};

;// CONCATENATED MODULE: ./utils/db/JobPost/getIsPublished.ts
const getIsPublished = (jobPost)=>{
    return !!jobPost.publishStartsAt && jobPost.publishStartsAt < new Date();
};

;// CONCATENATED MODULE: ./utils/db/JobPost/getIsStopped.ts
const getIsStopped = (jobPost)=>!!jobPost.stoppedAt;

;// CONCATENATED MODULE: ./utils/db/JobPost/getCompositeStatus.ts





var JobPostCompositeStatus;
(function(JobPostCompositeStatus) {
    JobPostCompositeStatus["DRAFT"] = "DRAFT";
    JobPostCompositeStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    JobPostCompositeStatus["APPROVED"] = "APPROVED";
    JobPostCompositeStatus["PUBLISHED"] = "PUBLISHED";
    JobPostCompositeStatus["STOPPED"] = "STOPPED";
    JobPostCompositeStatus["EXPIRED"] = "EXPIRED";
})(JobPostCompositeStatus || (JobPostCompositeStatus = {}));
const getCompositeStatus = (jobPost)=>{
    const isPaid = getIsPaid(jobPost);
    const isApproved = getIsApproved(jobPost);
    const isPublished = getIsPublished(jobPost);
    const isStopped = getIsStopped(jobPost);
    const isExpired = getIsExpired(jobPost);
    return isExpired ? JobPostCompositeStatus.EXPIRED : isStopped ? JobPostCompositeStatus.STOPPED : isPublished ? JobPostCompositeStatus.PUBLISHED : isApproved ? JobPostCompositeStatus.APPROVED : isPaid ? JobPostCompositeStatus.PENDING_APPROVAL : JobPostCompositeStatus.DRAFT;
};


/***/ }),

/***/ 59614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ moneyFormatter; }
/* harmony export */ });
const moneyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});


/***/ })

}]);